<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
            <div class="form-group">
              <label class="control-label">Team name</label>
              <input class="form-control" type="text" v-model="form.team_name" />
            </div>
            <div class="text-right">
              <button v-on:click="submit()"  :disabled="form.team_name.length == 0"class="btn btn-info btn-fill">Add Team</button>
            </div>
        </div>
        <div class="col-md-8" v-if="!loading">
            <enhanced-table nosearch="true" id='team-list' :datalist="teamData" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import axios from "axios";

  export default {
    components: {
      LTable,
    },
    data () {
      return {
        teamData: {},
        accessToken: null,
        loading: true,
        form: {
            team_name: ''
        }
      }
    },
    async created() {
      try {
        this.accessToken = await this.$auth.getAccessToken()
        this.loadData();
      } catch (e) {
        console.error(e)
      }
    },
    methods:{
      loadData() {
        axios
          .get('user/teams?access_token=' + this.accessToken, {})
          .then(response => (
              this.teamData = response.data,
              this.loading = false
          ));
      },
      submit() {
        axios
          .post('user/teams?access_token=' + this.accessToken, this.form)
          .then(function (response){
            if (response.status == 200){
              this.loadData()
            }
          }.bind(this))
      }
    },
  }

</script>
<style>

</style>
